/*
 * Module for the Distribution Option Selection step of the DROP Distribution Election form
*/
rs.module("ui/content/communications/onlineforms/distributionoptions",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "common/visibility"
    ],

    function (selectHelper, eventBanner, visibility) {
        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var distributionOptionRadio = stepContainer.js(jsSelectors.distributionOptionRadio, { multiple: true });
            var distributionOptionDescriptionDiv = stepContainer.js(jsSelectors.distributionOptionDescriptionDiv, { multiple: true });
            var partialPaymentAmount = stepContainer.js(jsSelectors.partialPaymentAmount);
            var partialInputWrapper = stepContainer.js(jsSelectors.partialInputWrapper);
            var isPartial = stepContainer.js(jsSelectors.isPartial, { multiple: true });

            var selected = distributionOptionRadio.filter(":checked");
            var selectedIndex = distributionOptionRadio.index(selected);
            if (selectedIndex !== null && selectedIndex >= 0) {
                showSelectedDistributionOptionDescription(selectedIndex);
                applyPartialAmountInputToSelectedOption(selected);
            }

            // Handle the distributionOptionRadio click event
            distributionOptionRadio.on("click", function () {

                var selectedIndex = distributionOptionRadio.index(this);
                showSelectedDistributionOptionDescription(selectedIndex);

                // Clear partial payment amount and errors
                partialPaymentAmount.val('');
                partialPaymentAmount.clearErrors();

                // Replace partial placeholder with input
                applyPartialAmountInputToSelectedOption(this);
            });

            // Show (slide down) the description for the selected distribution option
            function showSelectedDistributionOptionDescription(selectedIndex) {

                // Close all quickly
                distributionOptionDescriptionDiv.stop(true, true).slideUp(150);

                // Open the selected one
                distributionOptionDescriptionDiv.eq(selectedIndex).stop(true, true).slideDown(150);
            }

            // Apply partial input to placeholder
            function applyPartialAmountInputToSelectedOption(element) {
                partialInputWrapper.hide();

                const container = $(element).closest('.mt-2');

                const isPartialFlag = container.is(isPartial);

                if (isPartialFlag) {
                    const placeholder = container.find('.partial-input-placeholder');
                    placeholder.append(partialInputWrapper);
                    partialInputWrapper.show();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);